module.exports = __webpack_public_path__ + "img/hu1.e3a85eb7.jpg";